import { homePageHeroWidgetStyles } from "@solveindustrial/Widgets/VerndaleBox/HomePageHeroWidget";
import { css } from "styled-components";

homePageHeroWidgetStyles.wrapper = {
    css: css`
        width: 100%;
        position: relative;
        background-color: transparent;
    `,
};
